export const translationConfig = {
  common: ['Common.GameSorts'],
  feature: 'Feature.PlacesList'
};

export default translationConfig;
